import FingerPrintJS from '@fingerprintjs/fingerprintjs';
import DeviceDetector from 'device-detector-js';
import { useEffect, useState } from 'react';
import { UAParser } from 'ua-parser-js';

const normalizeDeviceType = type => {
	if (!type) return 'desktop';
	const t = type.toLowerCase();

	if (['smartphone', 'mobile', 'phablet', 'tablet', 'wearable'].includes(t)) return 'mobile';

	if (['desktop', 'tv', 'television', 'smart display', 'console', 'car'].includes(t)) return 'desktop';

	return 'desktop';
};

export async function getDeviceInfo() {
	const ua = navigator.userAgent || '';

	const parser = new UAParser(ua);
	const uaRes = parser.getResult();

	const dd = new DeviceDetector();
	const ddRes = dd.parse(ua);

	const fp = await FingerPrintJS.load();
	const fpResult = await fp.get();

	const detectedType = (ddRes.device && ddRes.device.type) || (uaRes.device && uaRes.device.type);
	const deviceType = normalizeDeviceType(detectedType);

	const deviceVendor = (ddRes.device && ddRes.device.brand) || (uaRes.device && uaRes.device.vendor) || null;

	const deviceModel =
		(ddRes.device && ddRes.device.model) || (uaRes.device && uaRes.device.model) || navigator.platform || null;

	const osName = (ddRes.os && ddRes.os.name) || uaRes.os || uaRes.os.name || '';
	const osVersion = (ddRes.os && ddRes.os.version) || uaRes.os || uaRes.os.version || '';
	const browserName = (ddRes.client && ddRes.client.name) || (uaRes.browser && uaRes.browser.name) || '';
	const browserVersion = (ddRes.client && ddRes.client.version) || (uaRes.browser && uaRes.browser.version) || '';

	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	const fingerprintId = fpResult.visitorId;

	const deviceInfo = {
		fingerprintId,
		deviceType,
		deviceVendor,
		deviceModel,
		osName,
		osVersion,
		browserName,
		browserVersion,
		timezone,
	};

	return deviceInfo;
}

